import { render, staticRenderFns } from "./four-hundreds.vue?vue&type=template&id=35b9af08&scoped=true&"
import script from "./four-hundreds.ts?vue&type=script&lang=ts&"
export * from "./four-hundreds.ts?vue&type=script&lang=ts&"
import style0 from "./four-hundreds.vue?vue&type=style&index=0&id=35b9af08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.1_cache-loader@4.1.0_webpack@4.44.2__css-loader@3.5.2_webpack@4.44.2__lodash@_woylw74pnr2dauffvwh757gxea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b9af08",
  null
  
)

export default component.exports